import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "SKU_" }
const _hoisted_8 = ["placeholder", "disabled"]
const _hoisted_9 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_10 = { for: "BarCode_" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upc" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["placeholder", "disabled"]
const _hoisted_14 = {
  key: 1,
  class: "my-1 error-style"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = ["onInput", "placeholder", "disabled"]
const _hoisted_18 = {
  key: 1,
  class: "row"
}
const _hoisted_19 = { class: "form-control" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { for: "PurchasePrice_" }
const _hoisted_23 = ["placeholder", "disabled"]
const _hoisted_24 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_25 = { for: "SellingPrice_" }
const _hoisted_26 = ["placeholder", "disabled"]
const _hoisted_27 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = { class: "d-flex justify-content-end" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_barcode = _resolveComponent("barcode")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.validationRules.fields.SKU.$error }])
            }, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.language.sku), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "SKU_",
                class: "form-control number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.SKU) = $event)),
                placeholder: '(' + _ctx.language.sku_ex.toLowerCase() + ')',
                maxlength: "12",
                autocomplete: "off",
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOnFocus($event))),
                disabled: _ctx.isSavingRecord
              }, null, 40, _hoisted_8), [
                [_vModelText, _ctx.dataRecord.SKU]
              ]),
              (_ctx.validationRules.fields.SKU.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.validationRules.fields.SKU.$errors[0]), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.validationRules.fields.BarCode.$error }])
            }, [
              _createElementVNode("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.language.barcode) + " ", 1),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateBarCode(null)))
                  }, _hoisted_12)
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "BarCode_",
                class: "form-control number",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.BarCode) = $event)),
                placeholder: '(' + _ctx.language.barcode_ex.toLowerCase() + ')',
                maxlength: "10",
                autocomplete: "off",
                onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeyUpRawBarcode && _ctx.onKeyUpRawBarcode(...args))),
                onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectOnFocus($event))),
                disabled: _ctx.isSavingRecord
              }, null, 40, _hoisted_13), [
                [_vModelText, _ctx.dataRecord.BarCode]
              ]),
              (_ctx.isBarCodeReady && _ctx.dataRecord.BarCode.length == 10)
                ? (_openBlock(), _createBlock(_component_barcode, {
                    key: 0,
                    value: _ctx.dataRecord.BarCode
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Show this if the rendering fails. ")
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.validationRules.fields.BarCode.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.validationRules.fields.BarCode.$errors[0]), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _hoisted_15,
          (_ctx.recordStatus == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variants, (xVar) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-6 form-group",
                    key: xVar.IdVariant
                  }, [
                    _createElementVNode("label", null, _toDisplayString(xVar.VariantCode), 1),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      onInput: ($event: any) => (_ctx.buildCodesData(xVar, $event)),
                      placeholder: '(' + xVar.VariantCode.toLowerCase() + ')',
                      maxlength: "25",
                      autocomplete: "off",
                      autofocus: "",
                      onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event))),
                      disabled: _ctx.isSavingRecord
                    }, null, 40, _hoisted_17)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.recordStatus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldEditorData, (xVar) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-6 form-group",
                    key: xVar.key
                  }, [
                    _createElementVNode("label", null, _toDisplayString(xVar.key), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(xVar.val), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.validationRules.fields.PurchasePrice.$error }])
            }, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.language.purchase_price), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "PurchasePrice_",
                class: "numeric form-control text-end",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.PurchasePrice) = $event)),
                placeholder: '(' + _ctx.language.purchase_price.toLowerCase() + ')',
                maxlength: "25",
                autocomplete: "off",
                autofocus: "",
                onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event))),
                disabled: _ctx.isSavingRecord
              }, null, 40, _hoisted_23), [
                [_vModelText, _ctx.dataRecord.PurchasePrice]
              ]),
              (_ctx.validationRules.fields.PurchasePrice.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.validationRules.fields.PurchasePrice.$errors[0]), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.validationRules.fields.SellingPrice.$error }])
            }, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.language.sell_price), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "SellingPrice_",
                class: "numeric form-control text-end",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dataRecord.SellingPrice) = $event)),
                placeholder: '(' + _ctx.language.sell_price.toLowerCase() + ')',
                maxlength: "25",
                autocomplete: "off",
                autofocus: "",
                onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectOnFocus($event))),
                disabled: _ctx.isSavingRecord
              }, null, 40, _hoisted_26), [
                [_vModelText, _ctx.dataRecord.SellingPrice]
              ]),
              (_ctx.validationRules.fields.SellingPrice.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.validationRules.fields.SellingPrice.$errors[0]), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_30),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
              disabled: _ctx.validationRules.$invalid || _ctx.isSavingRecord
            }, [
              (_ctx.isSavingRecord)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: ['fa', 'fa-save']
                  })),
              _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
            ], 8, _hoisted_31)
          ])
        ])
      ])
    ])
  ], 2))
}